import { render, staticRenderFns } from "./LRPopupMobileHeader.vue?vue&type=template&id=200923ca&scoped=true"
import script from "./LRPopupMobileHeader.vue?vue&type=script&lang=ts"
export * from "./LRPopupMobileHeader.vue?vue&type=script&lang=ts"
import style0 from "./LRPopupMobileHeader.vue?vue&type=style&index=0&id=200923ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200923ca",
  null
  
)

export default component.exports